var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowComponent
    ? _c(
        "a",
        {
          staticClass: "energy-datasheet-link",
          attrs: { href: _vm.parsedUrl, target: "_blank" }
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$translate("EnergyLabel::Template.energyLabelDatasheet")
              )
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }